import AmioHttpService from '@/services/amio/amio-http.service'

class IndexesService extends AmioHttpService {
  async create(name, sources, scheduleParams = null, extraParams = {}) {
    const payload = { name, sources, ...extraParams }
    if (scheduleParams) payload.schedule_params = scheduleParams
    try {
      const response = await this.requestPost('/indexes', payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(id, patchData) {
    try {
      const response = await this.requestPatch(`/indexes/${id}`, patchData)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async list() {
    try {
      const response = await this.requestGet('/indexes')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async getEmbeddingModels() {
    try {
      const response = await this.requestGet('/indexes/embedding-models')
      return response.data.models
    } catch (err) {
      throw this.handleError(err)
    }
  }

  // knowledge-base search (KB explorer).
  //  - mode 'raw' (default): the documents that would be fed to the LLM, no transformation.
  //      { query, provider, results: [{ id, score, title, content, payload }] }
  //  - mode 'rag': the full bot pipeline with every intermediate parameter, for debugging.
  //      { query, reformulated_query, provider, filterable_fields, proposed_filters, applied_filters,
  //        fell_back, results: [...] }
  //  - mode 'products' (PRO-740): { query, provider, cards } — the bot's own product cards, in `language`.
  async searchKnowledgeBase(indexId, { query, topN, mode, language } = {}) {
    try {
      const response = await this.requestPost(`/indexes/${indexId}/search`, { query, top_n: topN, mode, language })
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(id) {
    try {
      await this.requestDelete(`/indexes/${id}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }

}

export default new IndexesService()
